module.exports = __webpack_public_path__ + "static/media/fuwuxiaoshou1.d67b1225.png";